import { render, staticRenderFns } from "./ModalAddDescriptions.vue?vue&type=template&id=d795bf1c&scoped=true&"
import script from "./ModalAddDescriptions.vue?vue&type=script&lang=js&"
export * from "./ModalAddDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddDescriptions.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ModalAddDescriptions.vue?vue&type=style&index=1&id=d795bf1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d795bf1c",
  null
  
)

export default component.exports